// extracted by mini-css-extract-plugin
var _1 = "MembershipPermissionsSelectStep_commentSettings__RnpxM";
var _2 = "MembershipPermissionsSelectStep_commentSettingsRadio__1iIPI";
var _3 = "MembershipPermissionsSelectStep_commentSettingsText__Miw39";
var _4 = "MembershipPermissionsSelectStep_last__y3BLw";
var _5 = "MembershipPermissionsSelectStep_menuItemDescription__eEelM";
var _6 = "MembershipPermissionsSelectStep_menuItemTitle__eAo2O";
var _7 = "MembershipPermissionsSelectStep_selected__E45AX";
export { _1 as "commentSettings", _2 as "commentSettingsRadio", _3 as "commentSettingsText", _4 as "last", _5 as "menuItemDescription", _6 as "menuItemTitle", _7 as "selected" }
